// @ts-nocheck
import React from 'react';
import { ApplyPluginsType, dynamic } from '/root/workspace/ad-editor_hFqr/node_modules/@umijs/runtime';
import * as umiExports from './umiExports';
import { plugin } from './plugin';
import LoadingComponent from '@/components/LoadingCp';

export function getRoutes() {
  const routes = [
  {
    "exact": false,
    "path": "/",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__index' */'@/layouts/index'), loading: LoadingComponent}),
    "routes": [
      {
        "path": "/",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__home' */'/root/workspace/ad-editor_hFqr/src/pages/home'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/editor",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__editor' */'/root/workspace/ad-editor_hFqr/src/pages/editor'), loading: LoadingComponent}),
        "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/wrappers/auth'), loading: LoadingComponent})],
        "exact": true
      },
      {
        "path": "/tpl-list",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__templage' */'/root/workspace/ad-editor_hFqr/src/pages/templage'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/sso",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__sso' */'/root/workspace/ad-editor_hFqr/src/pages/sso'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/preview",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__editor__preview' */'/root/workspace/ad-editor_hFqr/src/pages/editor/preview'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/:linkCode",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__editor__preview' */'/root/workspace/ad-editor_hFqr/src/pages/editor/preview'), loading: LoadingComponent}),
        "exact": true
      }
    ]
  }
];

  // allow user to extend routes
  plugin.applyPlugins({
    key: 'patchRoutes',
    type: ApplyPluginsType.event,
    args: { routes },
  });

  return routes;
}
